import { composeValidators, requiredValidation } from 'validators';
export const MAX_PAGE_TITLE_LENGTH = 80;
export const pageTitleValidation = (t)=>composeValidators([
        requiredValidation(t.templates.fieldRequired()),
        {
            validate: {
                tooLong: (value)=>typeof value !== 'string' || value.length <= MAX_PAGE_TITLE_LENGTH || t.editTitle.tooLongError()
            }
        }
    ]);
